import ActionType from 'actions/ActionType'
const update = require('immutability-helper')

const firstFourStages = ['Awareness', 'Interest', 'Desire', 'Action']

export default (state = [], action) => {
	switch (action.type) {
		case ActionType.Campaign.REPLACE_PLACEHOLDER_TASK:
			if (typeof action?.payload?.taskIndexInStage === 'number') {
				return state.map((stage, index) => {
					if (index !== action?.payload?.stageIdx) return stage
					return {
						...stage,
						tasks: state?.[action?.payload?.stageIdx]?.tasks?.map?.(
							(task, idx) => {
								if (idx === action?.payload?.taskIndexInStage) {
									return action?.payload?.task?.id
								}
								return task
							},
						),
					}
				})
			}
			return state
		case ActionType.Campaign.ADD_PLACEHOLDER_TASK:
			if (typeof action?.stageIdx === 'number') {
				return state.map((stage, index) => {
					if (index !== action?.stageIdx) return stage
					return { ...stage, tasks: [...stage.tasks, action?.placeholderID] }
				})
			}
			return state
		case ActionType.Campaign.RECEIVE_CAMPAIGN:
			return action.payload && action.payload.stages
				? action.payload.stages.map((stage, idx) => ({
						...stage,
						event_goals: stage?.event_goals || [],
						// tasks: stage.tasks || [],
						tasks: state?.[idx]?.tasks || stage?.tasks || [],
				  }))
				: []
		case ActionType.Campaign.ADD_STAGE:
			return [
				...state,
				{
					name: action.payload
						? action.payload
						: firstFourStages[state.length]
						? firstFourStages[state.length]
						: `Stage ${String.fromCharCode((state.length % 26) + 65)}`,
					event_goals: [],
					tasks: [],
				},
			]
		case ActionType.Campaign.ADD_STAGE_SUCCESS:
			return action.payload && action.payload.stages
        ? action.payload.stages.map(stage => ({
						...stage,
						event_goals: stage.event_goals || [],
						tasks: stage.tasks || [],
				  }))
				: []
		case ActionType.Campaign.CHANGE_STAGE_NAME:
			return state.map((stage, index) => {
				if (index !== action.payload.index) return stage
				return { ...stage, name: action.payload.name }
			})
		case ActionType.Campaign.ADD_TASK_TO_CAMPAIGN:
			return state.map((stage, index) => {
				if (index !== action.payload.index) return stage
				return { ...stage, tasks: [...stage.tasks, action.payload] }
			})
    case ActionType.Campaign.ADD_EVENT_GOAL_TO_CAMPAIGN:
      return state.map((stage, index) => {
        if (index !== action.payload.index) return stage
        return {
          ...stage,
          event_goals:
            typeof action.payload.editIdx === 'number'
              ? stage.event_goals.map((evtGl, evtGlIdx) => {
								if (evtGlIdx !== action.payload.editIdx) return evtGl
								return action.payload.event_goal
							})
              : [...stage.event_goals, action.payload.event_goal],
        }
      })
		case ActionType.Campaign.MOVE_STAGE_TASK:
			return state.map((stage, index) => {
				const { stageIdx, dragIndex, hoverIndex } = action
				if (index !== stageIdx) return stage
				const { tasks } = state[stageIdx]
				const dragTask = tasks[dragIndex]

				return update(state[stageIdx], {
					tasks: {
						$splice: [
							[dragIndex, 1],
							[hoverIndex, 0, dragTask],
						],
					},
				})
			})
		case ActionType.Campaign.MOVE_STAGE:
			const { dragIndex, hoverIndex } = action
			const dragStage = state[dragIndex]
			return update(state, {
				$splice: [
					[dragIndex, 1],
					[hoverIndex, 0, dragStage],
				],
			})
		case ActionType.Campaign.DELETE_STAGE:
			return update(state, { $splice: [[action.stageIdx, 1]] })
		case ActionType.Campaign.REMOVE_EVENT_GOAL:
			return state.map((stage, index) => {
        const { stageIdx, eventGoalIdx } = action
        if (index !== stageIdx) return stage

        return {
          ...state?.[stageIdx],
          event_goals: state?.[stageIdx]?.event_goals
            ?.slice?.(0, eventGoalIdx)
            ?.concat?.(
              state?.[stageIdx]?.event_goals?.slice?.(eventGoalIdx + 1),
            ),
        }

        // return update(state[stageIdx], {
        // 	event_goals: {
        // 		$splice: [[eventGoalIdx, 1]],
        // 	},
        // })
      })
		case ActionType.Campaign.REMOVE_STAGE_TASK:
			return state.map((stage, index) => {
				const { stageIdx, taskIdx } = action
				if (index !== stageIdx) return stage

				return update(state[stageIdx], {
					tasks: {
						$splice: [[taskIdx, 1]],
					},
				})
			})
		case ActionType.Campaign.INGEST_PREDICTION:
			const numberEntityArr = action.payload.filter(
        el => el.type === 'builtin.number',
			)

			if (numberEntityArr.length) {
				return [...new Array(parseInt(numberEntityArr[0].entity))].map(
					(el, idx) => ({
						name: firstFourStages[state.length]
							? firstFourStages[state.length]
							: `Stage ${String.fromCharCode((idx % 26) + 65)}`,
						event_goals: [],
						tasks: [],
					}),
				)
			}

			return action.payload
        .filter(el => el.type === 'CAMPAIGN_STAGE')
        .map(el => ({ name: el.entity, event_goals: [], tasks: [] }))
		default:
			return state
	}
}
